import { ReactNode, createContext, useContext } from 'react'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'

export type EnvContextType = {
  ENV: string
  API_BASE_URL: string
  MIXPANEL_TOKEN: string
  MIXPANEL_ENABLE: boolean
  MOENGAGE_ENABLE: boolean
  FRESHCHAT_APP_ID: string
  FRESHCHAT_APP_KEY: string
  MOENGAGE_APP_ID: string
  AUGMONT_SILVER_URL: string
  APP_BUILD_ENV: string
  SENTRY_DSN: string
  FRESHDESK_DISPUTE_URL: string
  WEB_SOCKET_BASE_URL: string
  MOENGAGE_CLUSTER: string
  VRM_WEB_SOCKET_BASE_URL: string
}

const EnvContext = createContext<EnvContextType | undefined>(undefined)

export const EnvProvider = ({
  children,
  env,
}: {
  children: ReactNode
  env: EnvContextType
}) => {
  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

export const useEnv = () => {
  const envContext = useContext(EnvContext)
  // TODO: Need to add env config for my teams app also
  if (APP_NAME !== MY_TEAMS_ADVISOR && envContext == null) {
    throw new Error('You must wrap your app inside EnvProvider')
  }
  if (APP_NAME === MY_TEAMS_ADVISOR) {
    return {
      FRESHDESK_DISPUTE_URL:
        'https://onecode-asset.s3.ap-south-1.amazonaws.com/prod/raiseDispute.html',
    }
  }
  return envContext as EnvContextType
}
